import { gql } from "@apollo/client";

export const CREATE_ACCOUNT_TRANSACTION_FLOW_DOWNLOAD_TASK = gql`
    mutation CreateAccountTransactionFlowDownloadTask($filters: AccountTransactionFlowFilterTypeInput) {
        createAccountTransactionFlowDownloadTask(filters: $filters)
    }
`;

export interface AccountTransactionFlowDownloadTaskResponse {
    createAccountTransactionFlowDownloadTask: string;
}

